import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { approvalFormTableStyles } from '@/components/Approval/@components/ApprovalFormTable/styles';
import { infoSectionTitleStyles } from '@/components/Approval/@components/InfoSection/styles';

/** 저장 HTML(레거시 문서 포함)의 태그·클래스로 맞춤 — 표 제목은 label.label */
export const SerpLendingDelayRoot = styled(Box)(({ theme }) => ({
  width: '100%',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  '& label.label': {
    ...infoSectionTitleStyles,
    display: 'block',
    margin: '0 0 8px',
  },
  '& table': {
    ...approvalFormTableStyles(theme),
    tableLayout: 'auto',
    minWidth: 480,
  },
  '& table th, & table td': {
    textAlign: 'center',
  },
  '& tbody th': {
    fontWeight: 400,
  },
}));
